export default __webpack_public_path__ + "e4e52abb1843a5c082c93cacc7230bde.svg";